import { FC } from "react";
import { PanelSlider } from "../../../../components/ui";
import cancelIcon from "../../../../assets/images/close.svg";
import usePayoutView from "../bloc/usePayoutView";
import { getCurrencyNumberWithSymbol } from "../../../../helpers/get-currency-number";
import { getDateViewForamt } from "../../../../helpers/datetime";
import TitleValueWidget from "../../../../components/trade_value_widget/TitleValueWidget";
import { getPayoutStatus } from "../../../../helpers/payouts";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getCollectionStatus } from "../../../../helpers/getText";

const PayoutViewPage: FC<{
    open: boolean;
    onClose: () => void;
}> = ({
    open,
    onClose,
}) => {

        const {
            payoutView,
            payoutType,
            handleRefresh,
            isRefresh,
            payoutStatus
        } = usePayoutView();

        return (
            <PanelSlider
                open={open}
                onClose={onClose}
                direction="right_to_left"
                style={{ width: "40vw" }}
            >
                <div
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                    className="panel-content"
                >
                    <div className="border-b card_space_18 flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <h1 className="font-bold">
                                {getCurrencyNumberWithSymbol(payoutView.amount)}
                            </h1>
                            <span className="fs-12 color-sub-text">Created On</span>
                            <span className="fs-12 color-black">{getDateViewForamt(payoutView.createdOn)}</span>
                        </div>
                        <div>
                            <img
                                src={cancelIcon}
                                alt=""
                                className="cursor-pointer"
                                onClick={onClose}
                            />
                        </div>
                    </div>
                    <div className="p-5">
                        <div className="fs-16 mb-2">
                            {payoutType == "PAYOUT" ? "Payout Details" : "Collection Details"}
                        </div>
                        <div className="border-b"></div>
                        <div className="grid grid-cols-3 gap-x-4 gap-y-6 mt-3">
                            <TitleValueWidget
                                title={'UTR Number'}
                                value={payoutView.utr}
                            />
                            <TitleValueWidget
                                title={payoutType == "PAYOUT" ? 'Debit from' : 'Credit to'}
                                value={payoutView.debitFrom ?? ''}
                            />
                            {
                                payoutType == "PAYOUT" &&
                                <TitleValueWidget
                                    title={'Purpose'}
                                    value={payoutView.purpose ?? ''}
                                />
                            }
                            {
                                payoutType == "COLLECTION" &&
                                <TitleValueWidget
                                    title={'Customer Name'}
                                    value={payoutView.customerName ?? ''}
                                />
                            }
                            <TitleValueWidget
                                title={payoutType == "PAYOUT" ? 'Transfer Method' : 'Payment Method'}
                                value={payoutView.paymentMode}
                            />
                            {
                                payoutType == "PAYOUT" &&
                                <TitleValueWidget
                                    title={'Narration'}
                                    value={payoutView.narration ?? ''}
                                />
                            }
                            {
                                payoutType == "PAYOUT" &&
                                <TitleValueWidget
                                    title={'Payout ID'}
                                    value={payoutView.payoutId ?? ''}
                                />
                            }

                            {
                                payoutType === 'PAYOUT' &&
                                <TitleValueWidget
                                    title={'Payment Reference ID'}
                                    value={payoutView.pmtRefId ?? ''}
                                />
                            }

                            {
                                payoutType == "COLLECTION" &&
                                <TitleValueWidget
                                    title={'VA ID'}
                                    value={payoutView.vaId ?? ''}
                                />
                            }
                            {
                                payoutType == "PAYOUT" &&
                                <TitleValueWidget
                                    title="Status"
                                    value={getPayoutStatus(payoutView.status)}
                                />
                            }
                            {
                                payoutType == "COLLECTION" &&
                                <TitleValueWidget
                                    title="Status"
                                    value={getCollectionStatus(payoutView.status)}
                                />
                            }
                            {
                                payoutType == "PAYOUT" &&
                                <TitleValueWidget
                                    title={'Transaction Date & Time'}
                                    value={payoutView.transactionDateTime ?? ''}
                                />
                            }

                            {payoutView.status === 'INITIATED' && payoutType == "PAYOUT" && (
                                <div className="flex items-center space-x-2 mb-2.5">
                                    <TitleValueWidget
                                        title="Check Payout Status"
                                        value={getPayoutStatus(payoutStatus[0]?.transactionStatus) ?? '-'}
                                    />
                                    <>
                                        <div
                                            className="flex items-center cursor-pointer color-primary border-primary p-1 rounded-xl mb-2"
                                            onClick={handleRefresh}
                                            style={{ background: "#EBFFF0" }}
                                        >
                                            <RefreshIcon className={`${isRefresh ? "animate-spin" : ""} mr-1`} />
                                        </div>
                                    </>
                                </div>
                            )}

                             {
                                payoutType === 'PAYOUT' &&
                                <TitleValueWidget
                                    title={'Comments'}
                                    value={payoutView.comments ?? ''}
                                />
                            }
                            
                        </div>
                        <div className="mt-4">
                            {
                                payoutType == "COLLECTION" &&
                                <TitleValueWidget
                                    title="Description"
                                    value={payoutView.collectDesc}
                                />
                            }
                        </div>
                    </div>
                </div>
            </PanelSlider>
        );
    }

export default PayoutViewPage;